export const SET_LEADERBOARD = "SET_LEADERBOARD"